import { STATES } from '../../../../constants';

export function UpdateAccountsSearchConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_UPDATE_ACCOUNTS_SEARCH, {
    url: '/{category}',
    views: {
      '@': {
        template: '<upd-update-accounts-search></upd-update-accounts-search>',
      },
    },
    scrollTop: true,
    title: 'Search',
    titleBar: {
      icon: 'accounts',
      title: 'Update Your Accounts',
      save: 'Average Time Saved: 3 Hours',
    },
    analytics: {
      page: 'Search Update Accounts',
    },
  });
}
